import React, { useRef, useEffect } from 'react'
import { Button, Input, Icon, Spin, Tooltip } from 'antd'
import classNames from 'classnames'
import { ImagePreview } from '../../../../../../../components'

const PropItem = ({
  propKey,
  description,
  isPending,
  propReference,
  isGeneratingPropReference,
  generatingKeys,
  loadingTip,
  onEdit,
  onDelete,
  onSave,
  onCancelEdit,
  editingKey,
  editValue,
  setEditValue,
  propGenerationProgress,
  propGenerationStatus,
  onOpenImageEditor
}) => {
  const editRef = useRef(null)

  const refs = propReference || {}
  const refKey = refs[`__${propKey}__`] ? `__${propKey}__` : propKey
  const reference = refs[refKey]
  const imageSrc =
    reference &&
    (reference.uri || reference.url || reference.image || reference.src)
  const tag = reference && (reference.tag || reference.name)

  const isItemGenerating =
    isGeneratingPropReference &&
    (generatingKeys === 'ALL' ||
      (Array.isArray(generatingKeys) && generatingKeys.includes(propKey)))

  useEffect(() => {
    if (editingKey === propKey) {
      setTimeout(() => {
        try {
          if (
            editRef &&
            editRef.current &&
            typeof editRef.current.focus === 'function'
          )
            editRef.current.focus()
        } catch (e) {
          // ignore
        }
      }, 0)
    }
  }, [editingKey, propKey])

  return (
    <div
      className={classNames('lr-item-card', {
        'is-generating': isItemGenerating,
        'is-pending': isPending
      })}
      style={{
        opacity:
          isGeneratingPropReference && !isItemGenerating && generatingKeys
            ? 0.6
            : 1
      }}
    >
      <div className="lr-item-thumbnail">
        {(isGeneratingPropReference && !imageSrc) || isItemGenerating ? (
          <>
            <Spin
              tip={
                // loadingTip ||
                propGenerationProgress
                  ? `${propGenerationStatus ||
                      'Generating...'} ${propGenerationProgress}% `
                  : 'Regenerating...'
              }
            />
          </>
        ) : imageSrc ? (
          <ImagePreview src={imageSrc} alt={tag || propKey} />
        ) : isPending ? (
          <div className="draft-placeholder">
            <Icon type="edit" />
            <span>Draft</span>
          </div>
        ) : (
          <div className="no-image-placeholder">
            <Icon type="picture" />
            <span>No Image</span>
          </div>
        )}
      </div>

      <div className="lr-item-content">
        <div className="lr-item-header">
          <div className="lr-item-titles">
            <span className="lr-item-key" title={propKey}>
              {propKey}
            </span>
            {tag && <span className="lr-item-tag">({tag})</span>}
            {isPending && <span className="lr-item-badge">Draft</span>}
          </div>

          {!editingKey && (
            <div className="lr-item-actions">
              <Tooltip title="Open AI Studio to design or refine this prop's visual via chat">
                <Button
                  size="small"
                  onClick={() => onOpenImageEditor(propKey)}
                  disabled={isGeneratingPropReference}
                  style={{ marginRight: 8 }}
                >
                  <Icon type="picture" /> AI Image Studio
                </Button>
              </Tooltip>
              <Tooltip title="Edit the text description (prompt) used by the AI to generate the prop">
                <Button
                  size="small"
                  onClick={() => onEdit(propKey, description)}
                  disabled={isGeneratingPropReference}
                  style={{ marginRight: 8 }}
                >
                  <Icon type="edit" /> Edit Prompt
                </Button>
              </Tooltip>
              <Tooltip title="Remove this prop reference from the project">
                <Button
                  size="small"
                  danger
                  onClick={() => onDelete(propKey)}
                  disabled={isGeneratingPropReference}
                >
                  <Icon type="delete" /> Delete
                </Button>
              </Tooltip>
            </div>
          )}
        </div>

        {editingKey === propKey ? (
          <div className="lr-item-editor">
            <Input.TextArea
              ref={editRef}
              value={editValue}
              onChange={e => setEditValue(e.target.value)}
              rows={4}
              style={{ width: '100%' }}
            />
            <div className="lr-edit-actions">
              <Button
                type="primary"
                size="small"
                onClick={() => onSave(propKey)}
              >
                Save
              </Button>
              <Button size="small" onClick={onCancelEdit}>
                Cancel
              </Button>
            </div>
          </div>
        ) : (
          <div className="lr-item-description">{String(description)}</div>
        )}
      </div>
    </div>
  )
}

export default PropItem
